<template>
  <div class="">
    <div class="has-bg-white is-border">
      <div class=" columns is-gapless is-vcentered">
        <div class="column is-padding-left">
          <strong class="is-size-3">Agenda</strong>
        </div>
        <div class="column is-tab-like is-narrow is-padding-right-small">
          <div class="dropdown is-hoverable is-right">
            <div class="dropdown-trigger">
              <a class="button is-white is-min-width-0 is-padding-left-small is-padding-right-small">
                <span class="is-small" aria-haspopup="true"
                      aria-controls="dropdown-menu">
                    <i class="fal fa-filter"></i>
                </span>
              </a>
            </div>
            <div class="dropdown-menu" id="dropdown-menu" role="menu">
              <div class="dropdown-content has-text-left">
                <div class="control dropdown-item">
                  <input id="calendar-options" type="checkbox" name="column" class="is-checkradio is-circle"
                         :value="EVENT_TYPES.OPTIONS" v-model="displayedEvents">
                  <label for="calendar-options">Options</label>
                </div>
                <div class="control dropdown-item">
                  <input id="calendar-rdvs" type="checkbox" name="column" class="is-checkradio is-circle"
                         :value="EVENT_TYPES.RDVS" v-model="displayedEvents">
                  <label for="calendar-rdvs">Rendez-vous</label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <small-calendar-inline-day v-if="currentDay" :date="currentDay" @changeDay="updateCurrentDay">

      </small-calendar-inline-day>
      <div class="bulma-calendar is-border-top">
        <div class="calendar is-fluid is-borderless">
          <div class="calendar-nav is-white is-paddingless-left is-paddingless-right">
            <div class="calendar-nav-previous-month">
              <button @click="goToPrevMonth"
                      class="button is-ghost is-min-width-0 has-text-grey">
                <i class="fal fa-chevron-left"></i>
              </button>
            </div>
            <div class="is-size-3"><strong>{{currentMonth.format('MMMM YYYY') | cap}}</strong></div>
            <div class="calendar-nav-next-month">
              <button @click="goToNextMonth"
                      class="button is-ghost is-min-width-0 has-text-grey">
                <i class="fal fa-chevron-right"></i>
              </button>
            </div>
          </div>
          <div class="calendar-container">
            <div class="calendar-header">
              <div class="calendar-date">Lun.</div>
              <div class="calendar-date">Mar.</div>
              <div class="calendar-date">Mer.</div>
              <div class="calendar-date">Jeu.</div>
              <div class="calendar-date">Ven.</div>
              <div class="calendar-date">Sam.</div>
              <div class="calendar-date">Dim.</div>
            </div>
            <div class="calendar-body">
              <div class="calendar-body">
                <small-calendar-day v-for="day in days"
                                    :displayed-events="displayedEvents"
                                    :selected="currentDay && currentDay.isSame(day.date, 'day')"
                                    @open="selectDay"
                                    :key="day.key" :date="day.date"
                                    :class="{'is-disabled' : currentMonth.format('MM') !== day.date.format('MM')}">
                </small-calendar-day>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="column is-paddingless-left is-paddingless-right is-padding-top-xsmall is-padding-bottom-xsmall is-border-top is-border-dashed">
        <a @click.prevent.stop="open" class="button is-white is-size-7 is-paddingless-right">
        <span class="icon is-small">
            <i class="fal fa-calendar-plus"></i>
        </span>
          <span class="is-padding-right-small">Nouvelle action</span>
        </a>
        <!--<a @click.prevent.stop="newReminder" class="button is-white is-size-7 is-paddingless-right">
        <span class="icon is-small">
            <i class="fal fa-alarm-clock"></i>
        </span>
          <span class="is-padding-right-small">Créer un rappel</span>
        </a> -->
      </div>
    </div>
  </div>
</template>

<script>
  import { CalendarMx } from '../../../mixins'
  import { mapState } from 'vuex'
  import SmallCalendarDay from './SmallCalendarDay'
  import SmallCalendarInlineDay from './SmallCalendarInlineDay'
  import moment from 'moment'

  const EVENT_TYPES = Object.freeze({
    RDVS: 'RDVS',
    REMINDERS: 'REMINDERS',
    OPTIONS: 'OPTIONS',
    CALENDAR_EVENTS: 'CALENDAR_EVENTS'
  })

  export default {
    name: 'SmallCalendar',
    mixins: [CalendarMx],
    props: {},
    components: {
      SmallCalendarDay,
      SmallCalendarInlineDay
    },
    data () {
      return {
        displayedEvents: [EVENT_TYPES.OPTIONS, EVENT_TYPES.RDVS, EVENT_TYPES.REMINDERS],
        EVENT_TYPES: EVENT_TYPES,
        currentDay: moment()
      }
    },
    computed: {
      ...mapState(['calendarEvents', 'quickview'])
    },
    watch: {
      quickview ({mode, params, results}) {
        if (results) {
          if (mode === 'NEW_CALENDAR_ACTION') {
            let day
            let month
            let year
            if ('reminder' in results.val && results.val.reminder) {
              let date = moment(results.val.reminder.date)
              day = date.get('date')
              month = date.get('month')
              month = month + 1
              year = date.get('year')
              this.$router.push({ name: 'CalendarDayView', query: { day, month, year, panel: 'REMINDERS' } })
            } else if ('rdv' in results.val && results.val.rdv) {
              let date = moment(results.val.rdv.date)
              day = date.get('date')
              month = date.get('month')
              month = month + 1
              year = date.get('year')
              this.$router.push({ name: 'CalendarDayView', query: { day, month, year } })
            }
          }
        }
      }
    },
    methods: {
      open () {
        this.$store.commit('setQuickview', {mode: 'NEW_CALENDAR_ACTION'})
      },
      selectDay (day) {
        this.currentDay = day
      },
      updateCurrentDay (day) {
        this.currentDay = day
      },
      newReminder () {
        let params = {}
        if (this.currentDay) {
          params.date = this.currentDay.format('DD/MM/YYYY')
        }
        this.$store.commit('setQuickview', {mode: 'NEW_REMINDER', params: params})
      },
      newRdv () {
        let params = {}
        if (this.currentDay) {
          params.date = moment(this.currentDay, 'DD/MM/YYYY').hours(8).startOf('hour').toDate()
        }
        this.$router.push({name: 'CalendarCreate', query: params})
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/home/dashboard-admin/SmallCalendar.vue